export default "__VITE_ASSET__920bdd20__"